import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";

// custom hooks import
import useDataInputOption from "../../../hooks/useDataInputOption";
import useISPowner from "../../../hooks/useISPOwner";

// internal imports
import "../../Customer/customer.css";
import Loader from "../../../components/common/Loader";
import { FtextField } from "../../../components/common/FtextField";
import { addCollector } from "../../../features/apiCallReseller";
import ComponentCustomModal from "../../../components/common/customModal/ComponentCustomModal";
import useSelectorState from "../../../hooks/useSelectorState";
import { areasSubareasChecked } from "../../../pages/staff/staffCustomFucn";

const CollectorPost = ({ show, setShow }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // call the data input option function
  const inputPermission = {
    name: true,
    mobile: true,
    nid: true,
    address: true,
    email: true,
    status: true,
  };

  // get data input option from useDataInputOption hook
  const dataInputOption = useDataInputOption(inputPermission, null, false);

  // get user & current user data form useISPOwner hook
  const { ispOwnerId, currentUser } = useISPowner();

  //---> Get redux store state data from useSelectorState hooks
  const { areas, subAreas } = useSelectorState();

  // get reseller area data from redux store
  const area = useSelector((state) => state.area.area);

  // loading state
  const [isLoading, setIsLoading] = useState(false);
  const [areaSubareas, setAreaSubareas] = useState();

  // reseller all areas subarea handle
  useEffect(() => {
    let temp = [];

    areas?.map((val) =>
      subAreas?.map((sub) => {
        if (val.id === sub.area) {
          let subarea = {
            ...sub,
            isChecked: false,
          };
          temp.push(subarea);
        }
      }),
    );

    // set reseller subAreas checked key include
    setAreaSubareas(temp);
  }, [areas, subAreas]);

  // select area handle for the collector
  const areaSubareaSelectHandler = ({ target }) => {
    const { name, checked, id } = target;

    let subAreas = [...areaSubareas];

    if (name === "area") {
      subAreas = subAreas.map((val) =>
        val.area === id ? { ...val, isChecked: checked } : val,
      );
    } else {
      subAreas = subAreas.map((val) =>
        val.id === id ? { ...val, isChecked: checked } : val,
      );
    }

    // set collector areas
    setAreaSubareas(subAreas);
  };

  // collector create function handler
  const collectorPostHandler = async (data) => {
    const sendingData = {
      ...data,
      areas: areaSubareas.filter((val) => val.isChecked).map((val) => val.id),
      reseller: currentUser.reseller.id,
      ispOwner: ispOwnerId,
    };

    // call the add collector api
    addCollector(dispatch, sendingData, setIsLoading, setShow);
  };

  return (
    <>
      <ComponentCustomModal
        show={show}
        setShow={setShow}
        centered={false}
        size={"xl"}
        header={t("addNewCollector")}
        footer={
          <div className="displayGrid1 float-end">
            <button
              type="button"
              className="btn btn-secondary"
              disabled={isLoading}
              onClick={() => setShow(false)}
            >
              {t("cancel")}
            </button>

            <button
              type="submit"
              form="collectorPost"
              className="btn btn-success"
              disabled={isLoading}
            >
              {isLoading ? <Loader /> : t("submit")}
            </button>
          </div>
        }
      >
        <Formik
          initialValues={{
            ...dataInputOption?.inputInitialValues,
          }}
          validationSchema={dataInputOption?.validationSchema}
          onSubmit={(values) => {
            collectorPostHandler(values);
          }}
          enableReinitialize
        >
          {() => (
            <Form id="collectorPost">
              <div className="d-flex justify-content-center">
                <div className="displayGrid col-6">
                  {dataInputOption?.inputOption.map(
                    (item) => item?.isVisible && <FtextField {...item} />,
                  )}
                </div>
              </div>

              {/* collector area select option */}
              <Card className="mt-3 bg-light">
                <Card.Body>
                  <Card.Title className="inputLabelFontColor">
                    {t("selectArea")}
                  </Card.Title>
                  <Card.Text>
                    <div className="displayGrid4">
                      {area?.map((val, key) => (
                        <div key={key}>
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              name="area"
                              id={val.id}
                              onChange={areaSubareaSelectHandler}
                              checked={
                                areaSubareas &&
                                areasSubareasChecked(val.id, areaSubareas)
                              }
                            />

                            <label htmlFor={val.id} className="areaParent ms-1">
                              {val.name}
                            </label>
                          </div>

                          {areaSubareas?.map(
                            (subArea, k) =>
                              subArea.area === val.id && (
                                <div key={k} className="displayFlex">
                                  <input
                                    type="checkbox"
                                    id={subArea.id}
                                    checked={subArea.isChecked}
                                    onChange={areaSubareaSelectHandler}
                                  />
                                  <label
                                    htmlFor={subArea.id}
                                    className="text-secondary"
                                  >
                                    {subArea.name}
                                  </label>
                                </div>
                              ),
                          )}
                        </div>
                      ))}
                    </div>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Form>
          )}
        </Formik>
      </ComponentCustomModal>
    </>
  );
};

export default CollectorPost;
